import React, {useMemo, useState} from "react";
import {Button, Checkbox, Col, Dropdown, Menu, Row, Space, Tooltip} from "antd";
import {ChevronRightIcon, DiamondIcon, FlameIcon, PriceListIcon, StorageBoxOutlineIcon} from "@components/icons/Icons";
import {FmvPrice} from "@components/fmv-price";
import {KeyIssueBadge} from "@components/key-issue-badge";
import {Link} from "react-router-dom";
import {getMyCollectionUrlWithIssueId} from "@lib/Routes";
import {EllipsisOutlined} from "@ant-design/icons";
import {getDefaultFmvDataFromIssue} from "@components/comic-grade-select";
import {getEbayTitleFromIssue} from "@lib/format";
import ebay_logo from "@images/ebay_logo.png";

const IssuesListItemDesktopNoImage = ({
      item,
      showEditMultiple,
      isSelected,
      toggleSelected,
      onClick,
      issueDate,
      showValueRibbon,
      allowUnlimited,
      navigate,
      windowDimensions,
      showListViewNoImages,
      setPriceListId,
      isLoggedIn,
      wishlistIssueAdd,
      wishlistIssueRemove,
      setAddIssueId,
      listViewColumns,
      shopLink,
}) => {
    const smallButtons = useMemo(() => {
        return windowDimensions.under(1200);
    }, [windowDimensions]);

    const ebayTitle = useMemo(() => getEbayTitleFromIssue(item), [item]);

    const [fmvData, setFmvData] = useState(getDefaultFmvDataFromIssue(item));

    const actionsColSpan = useMemo(() => {
        const smaller = windowDimensions.under(1001);
        let colSpan = 5;
        if(showEditMultiple) colSpan = colSpan-1;
        return colSpan;
    }, [showEditMultiple, windowDimensions]);

    return (
        <div className="grid-list-item">
            <Row className={"grid-list-item-inner"}>
                {(showEditMultiple && toggleSelected) && (
                    <Col span={1} className={"col-cbx flex-align-center "}>
                        <Checkbox checked={isSelected} onChange={() => toggleSelected(item.id)}/>
                    </Col>
                )}

                <Col className="no-wrap flex-vertical-center" span={2}>
                    {item.issue_number}
                </Col>

                <Col span={3}
                     className={'flex-row flex-vertical-center'}>
                    {(item.is_key || item.is_hot || item.is_rare) && (
                        <div
                            className={"valueBadges no-wrap mar-left-10"}>
                            {item.is_key && (<KeyIssueBadge keyInfo={item.key_info} windowDimensions={windowDimensions}
                                                            isLargeScreen={true}/>)}
                            {item.is_hot && (<div className="valueBadge hotIssue isActive"><FlameIcon/></div>)}
                            {item.is_rare && (<div className="valueBadge rareIssue isActive"><DiamondIcon/></div>)}
                        </div>
                    )}
                    {item.total_in_collection > 0 && (
                        <div className={"mar-left-10 "}>
                            <Link to={getMyCollectionUrlWithIssueId(item.id)}>
                                <span className="issues-owned">
                                    <StorageBoxOutlineIcon/><strong>&nbsp;:&nbsp;<span
                                    className="total-number">{item.total_in_collection}</span></strong>
                                </span>
                            </Link>
                        </div>
                    )}
                </Col>
                <Col className="no-wrap flex-vertical-center" span={2}>
                    {issueDate.getFullYear()}
                </Col>
                <Col className=" flex-vertical-center" span={3}>
                    {item.variant_name}
                </Col>
                <Col className="no-wrap flex-vertical-center flex-align-center" span={3}>
                    <div className="mar-auto-0 flex" style={{color: '#4C8391'}}>
                        {showValueRibbon ? (
                            <FmvPrice prefix={item.raw_fmv_grade ? item.raw_fmv_grade + ' | ' : null}
                                      value={item.raw_fmv_value} stale={item.raw_fmv_stale}/>
                        ) : (
                            <div>
                                <a className="upgrade-link" href="/plans/unlimited/">Upgrade</a>
                            </div>
                        )}
                    </div>
                </Col>
                <Col className="no-wrap flex-vertical-center flex-align-center" span={3}>
                    <div className="mar-auto-0 flex" style={{color: '#34A09A'}}>
                        {showValueRibbon ? (
                            <FmvPrice prefix={item.slabbed_fmv_grade ? item.slabbed_fmv_grade + ' | ' : null}
                                      value={item.slabbed_fmv_value} stale={item.slabbed_fmv_stale}/>
                        ) : (
                            <div>
                                <a className="upgrade-link" href="/plans/unlimited/">Upgrade</a>
                            </div>
                        )}
                    </div>
                </Col>

                <Col className="no-wrap flex-vertical-center" span={2}>
                    {shopLink ? (
                        <a href={shopLink.link_url} target="_blank" className={`ebay-link ${shopLink.className || ''}`}>
                            <img src={shopLink.image} className={"ebay-logo"}/>
                        </a>
                    ) : (
                        <a
                            href={`https://www.ebay.com/sch/63/i.html?_from=R40&_nkw=${ebayTitle}&mkcid=1&mkrid=711-53200-19255-0&siteid=0&campid=5339059464&toolid=20008&mkevt=1`}
                            target="_blank" className="ebay-link"
                        >
                            <img src={ebay_logo} className={"ebay-logo"}/>
                        </a>
                    )}
                </Col>

                <Col className="no-wrap flex-vertical-center flex-align-center" span={actionsColSpan}>
                    <Row className="issue-actions" justify="center">
                        <Space>
                            <Tooltip title="Show Price Table">
                                {smallButtons ? (
                                    <Button
                                        className="greyButton mar-left-5"
                                        style={{marginTop: -1}}
                                        size={smallButtons ? "small" : "large"}
                                        onClick={() => setPriceListId(item.id)}
                                    >
                                        <PriceListIcon className="icon16 iconDarkGrey"/>
                                    </Button>
                                ) : (
                                    <Button
                                        onClick={() => setPriceListId(item.id)}
                                        type="link"
                                        className={'price-list-btn'}
                                        style={{paddingRight: 0}}
                                        icon={<PriceListIcon className={`icon16 `}/>}
                                    >Price Table</Button>
                                )}

                            </Tooltip>

                            <Dropdown className="greyButton selectButton" trigger={["click"]} overlay={(
                                <Menu>
                                    {isLoggedIn && (
                                        <>
                                            <Menu.Item key={1} onClick={() => setAddIssueId(item.id)}>Add to
                                                Collection</Menu.Item>
                                            <Menu.Item key={2} onClick={() => {
                                                if (item.in_wishlist) {
                                                    wishlistIssueRemove([item.id]);
                                                } else {
                                                    wishlistIssueAdd([item.id]);
                                                }
                                            }}>{item.in_wishlist ? "Remove from Wishlist" : "Add to Wishlist"}</Menu.Item>
                                        </>
                                    )}
                                    <Menu.Item key={3}>
                                        <a href={`/marketplace/?issue_id=${item.id}`}>Buy In Marketplace</a>
                                    </Menu.Item>
                                    <Menu.Item key={4}>
                                        <a href={`/issue/${item.slug}`}>Go to Price Guide</a>
                                    </Menu.Item>
                                </Menu>
                            )}>
                                <Tooltip title="Actions">
                                    <Button className="greyButton mar-left-5" size={smallButtons ? "small" : "large"}>
                                        <EllipsisOutlined className="icon16 iconDarkGrey"/>
                                    </Button>
                                </Tooltip>
                            </Dropdown>
                        </Space>
                    </Row>
                </Col>

                <Col className="no-wrap flex-vertical-center flex-align-right" span={1}>
                    <Tooltip title="Go to Price Guide">
                        <Button type="text" size={smallButtons ? "middle" : "large"} className="pad-0"
                                href={`/issue/${item.slug}`}>
                            <ChevronRightIcon className="icon30 iconGrey"/>
                        </Button>
                    </Tooltip>
                </Col>
            </Row>
        </div>
    );
};

export default IssuesListItemDesktopNoImage;